module.exports = __webpack_public_path__ + "static/media/menuAccount.586219f7.svg";